import * as React from 'react';
import PropTypes from 'prop-types';

import {isEmbed} from 'utils/media';
import xClass from 'utils/xClass';
import {Fader} from 'ui-components/animations';

import About from 'components/About';
import ThankYou from 'containers/ThankYouContainer';
import {Video} from './Video';
// import CanvasPicture from 'ui-components/CanvasPicture';
import DivPicture from 'ui-components/DivPicture';

import {getImageSrc} from 'utils/paths';

import Work from 'types/Work';

interface PieceProps{
	mouseSide: number;
	setMouseSide: (newSide: number) => void;
	work: Work;
	next: () => void;
	previous: () => void;
	videoEnded: () => void;
	auto: boolean;
}

export class Piece extends React.Component<PieceProps>{

	private el: HTMLElement;

	mouseMove = e => {
		let {mouseSide} = this.props;
		let sideNow = this.mouseSide(e);
		if (sideNow !== mouseSide){
			this.props.setMouseSide(sideNow);
		}
	}

	mouseLeave = () => {
		this.props.setMouseSide(null);
	}

	mouseSide = (e) => {
		let pos = this.mousePos(e);
		if (!pos){
			return null;
		}
		return pos < 0.5 ? -1 : 1;
	}

	mousePos = e => {
		if (this.el){
			let mouseX = e.clientX;
			let elementWidth = this.el.clientWidth;
			return mouseX / elementWidth;
		}
		return null;
	}

	divLoaded = div => {
		this.el = div;
	}

	render(){
		let {
			work,
			next,
			previous,
			mouseSide,
			videoEnded,
			auto
		} = this.props;

		return (
			<div
				ref={this.divLoaded}
				onMouseMove={this.mouseMove}
				onMouseLeave={this.mouseLeave}
				className={xClass(
					'gallery-piece',
					{'nav-left': mouseSide === -1},
					{'nav-right': mouseSide === 1}
				)}
			>
				<Fader>{
					work ? (
						work.id == "about"
						? <About next={next}/>

						: work.id == "ty"
						? <ThankYou/>
						
						:  work.type == 'image'
						? <DivPicture
							key={work.id}
							src={getImageSrc(work)}
						/>
						
						: work.type == 'video'
						? <div key={work.id}
							className={xClass('piece', work.type)}
						>
							<Video
								url={work.filename}
								videoEnded={videoEnded}
								auto={auto}
							/>
						</div>

						: work.type == 'multi'
						? <div key={work.id}
							className={xClass(
								'piece',
								work.type,
								work.class
							)}
						><div>{work.filename.map(img => 
							<img key={img} src={getImageSrc(img)}/>
						)}</div>
						</div>
						
						: isEmbed(work)
						? <div
							key={work.id}
							className={xClass(
								'piece',
								'embed',
								work.type
							)}
							dangerouslySetInnerHTML={{
								__html: work.filename
							}}
						/>
						: null
					) : null
				}</Fader>
			</div>
		);
	}

}
export default Piece;